import React from 'react';
import styled from 'styled-components';

import Console from './Console';

type Props = {
  logQueue: StringKAnyVPair[],
};

const ToolboxWrapper = styled.div`
  height: 100%;
`;

const ScanTool = (props: Props) => {
  return (
    <ToolboxWrapper>
      <Console
        logQueue={props.logQueue}
      />
    </ToolboxWrapper>
  );
};

export default ScanTool;
